import { Achievement } from '../types/profile';

// Achievement definitions - easily migrated to Supabase table later
export const ACHIEVEMENTS: Achievement[] = [
  // Beginner achievements
  {
    id: 'first_game',
    name: 'Getting Started',
    description: 'Complete your first game',
    icon: '🎮',
    category: 'beginner',
    requirement: { type: 'games_played', value: 1 },
    points: 10
  },
  {
    id: 'first_perfect',
    name: 'Bullseye',
    description: 'Get 100% accuracy on a question',
    icon: '🎯',
    category: 'beginner',
    requirement: { type: 'perfect_questions', value: 1 },
    points: 15
  },
  {
    id: 'first_streak',
    name: 'On Fire',
    description: 'Get a 3-question streak',
    icon: '🔥',
    category: 'beginner',
    requirement: { type: 'streak', value: 3 },
    points: 20
  },

  // Consistency achievements
  {
    id: 'regular_player',
    name: 'Regular Player',
    description: 'Play 5 games',
    icon: '📅',
    category: 'consistency',
    requirement: { type: 'games_played', value: 5 },
    points: 25
  },
  {
    id: 'dedicated_player',
    name: 'Dedicated Player',
    description: 'Play 25 games',
    icon: '🏆',
    category: 'consistency',
    requirement: { type: 'games_played', value: 25 },
    points: 50
  },
  {
    id: 'score_hunter',
    name: 'Score Hunter',
    description: 'Reach 1000 total points',
    icon: '💯',
    category: 'consistency',
    requirement: { type: 'total_score', value: 1000 },
    points: 30
  },

  // Mastery achievements
  {
    id: 'streak_master',
    name: 'Streak Master',
    description: 'Get a 5-question streak',
    icon: '⚡',
    category: 'mastery',
    requirement: { type: 'streak', value: 5 },
    points: 40
  },
  {
    id: 'perfectionist',
    name: 'Perfectionist',
    description: 'Get 10 perfect answers',
    icon: '✨',
    category: 'mastery',
    requirement: { type: 'perfect_questions', value: 10 },
    points: 60
  },
  {
    id: 'hard_mode_hero',
    name: 'Hard Mode Hero',
    description: 'Complete 5 hard difficulty games',
    icon: '💪',
    category: 'mastery',
    requirement: { type: 'game_mode_games', value: 5, difficulty: 'hard' },
    points: 75
  },

  // Explorer achievements
  {
    id: 'length_explorer',
    name: 'Length Explorer',
    description: 'Play 10 length-focused games',
    icon: '📏',
    category: 'explorer',
    requirement: { type: 'measurement_games', value: 10, measurementType: 'length' },
    points: 35
  },
  {
    id: 'weight_explorer',
    name: 'Weight Explorer',
    description: 'Play 10 weight-focused games',
    icon: '⚖️',
    category: 'explorer',
    requirement: { type: 'measurement_games', value: 10, measurementType: 'weight' },
    points: 35
  },
  {
    id: 'volume_explorer',
    name: 'Volume Explorer',
    description: 'Play 10 volume-focused games',
    icon: '📦',
    category: 'explorer',
    requirement: { type: 'measurement_games', value: 10, measurementType: 'volume' },
    points: 35
  },
  {
    id: 'mode_explorer',
    name: 'Mode Explorer',
    description: 'Try all 6 game modes',
    icon: '🗺️',
    category: 'explorer',
    requirement: { type: 'game_mode_games', value: 6 }, // Special logic needed
    points: 50
  },

  // Challenger achievements
  {
    id: 'high_scorer',
    name: 'High Scorer',
    description: 'Score 800+ points in a single game',
    icon: '🌟',
    category: 'challenger',
    requirement: { type: 'total_score', value: 800 }, // Special logic for single game
    points: 80
  },
  {
    id: 'unstoppable',
    name: 'Unstoppable',
    description: 'Get a 10-question streak',
    icon: '🚀',
    category: 'challenger',
    requirement: { type: 'streak', value: 10 },
    points: 100
  },
  {
    id: 'measurement_master',
    name: 'Measurement Master',
    description: 'Master all three measurement types',
    icon: '🎓',
    category: 'challenger',
    requirement: { type: 'measurement_games', value: 50 }, // Special logic for all types
    points: 150,
    hidden: true
  },

  // Secret achievements
  {
    id: 'banana_lover',
    name: 'Banana Lover',
    description: 'Play 100 games (you really love bananas!)',
    icon: '🍌',
    category: 'challenger',
    requirement: { type: 'games_played', value: 100 },
    points: 200,
    hidden: true
  }
];

// Helper function to get achievements by category
export const getAchievementsByCategory = (category: Achievement['category']): Achievement[] => {
  return ACHIEVEMENTS.filter(achievement => achievement.category === category);
};

// Helper function to get visible achievements (non-hidden)
export const getVisibleAchievements = (): Achievement[] => {
  return ACHIEVEMENTS.filter(achievement => !achievement.hidden);
};

// Helper function to find achievement by ID
export const getAchievementById = (id: string): Achievement | undefined => {
  return ACHIEVEMENTS.find(achievement => achievement.id === id);
}; 